import {Component, OnInit} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {DropdownOption} from "../../../../../models/dropdown-option.model";
import * as Validation from "../../../../shared/constants/validation.constants";
import {FormControl, FormGroup} from "@angular/forms";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {CommonService} from "../../../../shared/services/common.service";
import {roles} from "../../../../shared/constants/common.constants";
import {FetchGroupsStatusFilterRequest, FetchGroupsTypeFilterRequest} from "../../core/coach-groups-list.actions";
import {groupsStatusFilter, groupsTypeFilter} from "../../core/coach-groups-list.selectors";
import {CoachGroupsListService} from "../../service/coach-groups-list.service";

@Component({
  selector: 'app-coach-groups-list-filter',
  templateUrl: './coach-groups-list-filter.component.html',
  styleUrls: ['./coach-groups-list-filter.component.css']
})
export class CoachGroupsListFilterComponent implements OnInit {

  private readonly OnDestroy: Subject<any> = new Subject<any>();
  protected readonly roles = roles;

  loading: boolean = false;
  groupsStatusFilter: DropdownOption[] = [];
  groupsTypeFilter: DropdownOption[] = [];
  groupsStatusLoading: boolean = false;
  groupsTypeLoading: boolean = false;
  role: number;
  errorMessages: any = {};
  validation = Validation;
  errorMessageMap = {
    'groupType': {
      required: 'This field is required.'
    },
    'groupStatus': {
      required: 'This field is required.'
    },
    'search': {
      required: 'This field is required.'
    }
  }

  form = new FormGroup<any>({
    groupType: new FormControl({value: null, disabled: false}),
    groupStatus: new FormControl({value: null, disabled: false}),
    search: new FormControl({value: null, disabled: false}),
  })

  constructor(
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private coachGroupListService: CoachGroupsListService
  ) {
    this.store.dispatch(FetchGroupsTypeFilterRequest());
    this.store.dispatch(FetchGroupsStatusFilterRequest());
  }

  ngOnInit() {

    this.store
      .select(groupsTypeFilter)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.groupsTypeFilter = data?.list
        this.groupsTypeLoading = data?.loading
      });

    this.store
      .select((groupsStatusFilter))
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.groupsStatusFilter = data?.list
        this.groupsStatusLoading = data?.loading
      });
  }

  apply() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }
    // EXTRACT VALUE FROM FORM//
    const {groupType, groupStatus, search} = this.form.getRawValue();
    // PAYLOAD CREATION//
    const filters = {
      type: groupType,
      status: groupStatus,
      searchText: search
    };
    // ACTION DISPATCH
    this.coachGroupListService.onGroupFilterChange.next(filters);
  }


  checkForErrors(currentField ?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }


}
